import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './routes/AppRouter';
import registerServiceWorker from './registerServiceWorker';
// import Call from './call/App';
import { Provider } from 'react-redux';
import store from './store/store';
import * as Sentry from '@sentry/browser';

Sentry.init({
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE
});

ReactDOM.render(
    <Provider store={store}>
        <AppRouter />
    </Provider>,
    // <Call />,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// /src/index.js